export default __webpack_public_path__ + "static/media/work4.0c612190.jpg";